import React, { useState, useEffect } from "react";
import step1Img from "../../assets/Plan.png";
import step2Img from "../../assets/Order.png";
import step3Img from "../../assets/Delivery.png";

export default function Steps() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    section: {
      padding: "4rem 8%",
      backgroundColor: "#fff",
      textAlign: "center",
    },
    heading: {
      fontSize: "2.5rem",
      fontWeight: "bold",
      lineHeight: "1",
      marginBottom: "2rem",
      fontFamily: "'Poppins', sans-serif",
      color: "#1a202c",
    },
    highlight: {
      color: "#f97316",
      fontFamily: "'Poppins', sans-serif",
    },
    stepsContainer: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // dynamic
      gap: "2rem",
      justifyContent: "center",
      maxWidth: "1000px",
      margin: "0 auto",
    },
    step: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#fff",
      borderRadius: "1rem",
      textAlign: "center",
      flex: "1",
      minWidth: isMobile ? "100%" : "250px",
      marginBottom: "2rem",
      boxShadow: "0 8px 20px 4px rgba(0,0,0,0.2)",
    },
    image: {
      width: isMobile ? "150px" : "211px",
      height: isMobile ? "150px" : "198px",
      objectFit: "contain",
      marginBottom: "1rem",
    },
    stepTitle: {
      fontSize: "1.4rem",
      fontWeight: "600",
      marginBottom: "0.5rem",
      fontFamily: "'Poppins', sans-serif",
      color: "#1a202c",
    },
    stepText: {
      fontSize: "1rem",
      color: "#555",
      lineHeight: "1.6",
      maxWidth: "400px",
    },
  };

  return (
    <section style={styles.section}>
      <span style={styles.highlight}>How It Works</span>
      <h2
        style={{
          ...styles.highlight,
          fontSize: "2.5rem",
          marginBottom: "1rem",
        }}
      >
        Home Made Food <span style={styles.heading}>Delivered</span>
      </h2>
      <h2>
        <span style={styles.heading}>To Your Doorstep</span>
      </h2>

      <div style={styles.stepsContainer}>
        <div style={styles.step}>
          <img src={step1Img} alt="Choose Meal" style={styles.image} />
          <h3 style={styles.stepTitle}>Choose Your Meal</h3>
          <p style={styles.stepText}>
            Browse our menu and select the dishes that suit your taste and
            dietary preferences.
          </p>
        </div>
        <div style={styles.step}>
          <img src={step2Img} alt="Place Order" style={styles.image} />
          <h3 style={styles.stepTitle}>Place Your Order</h3>
          <p style={styles.stepText}>
            Order easily through our website or app with secure payment options.
          </p>
        </div>
        <div style={styles.step}>
          <img src={step3Img} alt="Enjoy Delivery" style={styles.image} />
          <h3 style={styles.stepTitle}>Enjoy Delivery</h3>
          <p style={styles.stepText}>
            Get your fresh meal delivered to your doorstep at your preferred
            time.
          </p>
        </div>
      </div>
    </section>
  );
}
